import { createReducer, on } from '@ngrx/store';
import { changeSearchTypes, searchChangeCategoryPageNum, } from 'SearchAllApp/state/search-all-params/search-all-params.actions';
export const searchCategoryPageNum = createReducer({}, on(searchChangeCategoryPageNum, (_, action) => {
    return action.searchCategoryPageNum;
}), on(changeSearchTypes, () => {
    return {};
}));
